const THEMES = ['obsidian', 'chalk', 'slate']
const KEY = 'yqa-theme'

export function getTheme() {
  return document.documentElement.getAttribute('data-theme') || 'obsidian'
}

export function setTheme(theme) {
  if (!THEMES.includes(theme)) return
  document.documentElement.setAttribute('data-theme', theme)
  localStorage.setItem(KEY, theme)
  document.dispatchEvent(new CustomEvent('yqa:theme-change', { detail: { theme } }))
}

export function cycleTheme() {
  const idx = THEMES.indexOf(getTheme())
  setTheme(THEMES[(idx + 1) % THEMES.length])
}
